import { Channel } from '@at/consumer-web-types';
export const CARS_DEFAULT_FINANCE = '10000_1000_48';
export const CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE = '10000_10%_48';
export const VANS_PAST_DEFAULT_FINANCE = '10000_3000_48';
export const VANS_DEFAULT_FINANCE = '10000_5000_48';
export const BIKES_DEFAULT_FINANCE = '6000_1000_48';
export const CARS_DEFAULT_FINANCE_STRING = '48 month term, £1,000 deposit and 10,000 miles/year';
export const CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE_STRING = '48 month term, 10% deposit and 10,000 miles/year';
export const VANS_PAST_DEFAULT_FINANCE_STRING = '48 month term, £3,000 deposit and 10,000 miles/year';
export const VANS_DEFAULT_FINANCE_STRING = '48 month term, £5,000 deposit and 10,000 miles/year';
export const BIKES_DEFAULT_FINANCE_STRING = '48 month term, £1,000 deposit and 6,000 miles/year';
export const decodeFinanceOption = (option) => {
    const financeValue = option.split('_');
    return { mileage: financeValue[0], deposit: financeValue[1], term: financeValue[2] };
};
export const encodeFinanceOption = (options) => {
    return `${options.mileage}_${options.deposit}_${options.term}`;
};
export const getDefaultFinanceOptions = (channel, displayFinanceDepositAsPercentageOfVehicleValue) => {
    switch (channel) {
        case Channel.vans:
            return {
                value: VANS_DEFAULT_FINANCE,
                string: VANS_DEFAULT_FINANCE_STRING,
            };
        case Channel.bikes:
            return { value: BIKES_DEFAULT_FINANCE, string: BIKES_DEFAULT_FINANCE_STRING };
        default:
            if (displayFinanceDepositAsPercentageOfVehicleValue) {
                return {
                    value: CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE,
                    string: CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE_STRING,
                };
            }
            return { value: CARS_DEFAULT_FINANCE, string: CARS_DEFAULT_FINANCE_STRING };
    }
};
export const buildToggleOptions = (data) => {
    let options = [];
    data.forEach((item) => {
        const option = {
            label: item.value,
            value: item.value,
            selected: item.selected,
            disabled: false,
        };
        options.push(option);
    });
    return options;
};
